// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_2R30X","share-button":"_3bUf3","sms":"_37e5_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/SmsShareButton.scss
// module id = ./src/components/ShareModal/SmsShareButton.scss
// module chunks = 5